// icon:bx-receipt | Boxicons https://boxicons.com/ | Atisa
import * as React from "react";
import Icon from "../../images/art/icons/Leaflets.png"

function IconBxReceipt(props) {
	return (
		<img src={Icon} style={{ height: '1em', width: '1em', ...props }} alt={"Leaflets"} />
	)
}

export default IconBxReceipt;
